<div class="flex flex-col w-full h-full">
  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'locationChangeRequest' | transloco }}</div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto p-6 sm:p-8">
    @if (requestData) {
      <p class="px-2 py-4 text-lg font-semibold">{{ requestData.reason | localize }}</p>
    }
    <div class="flex items-center mb-4">
      <fuse-card class="flex flex-col px-8 py-6 pb-4 bg-primary text-on-primary w-1/2" #fuseCard>
        <div class="text-xl">{{ data.item.name }}</div>
        <div class="text-md">{{ data.item.address.vicinity }}</div>
      </fuse-card>
      <mat-icon class="mx-2" svgIcon="mat_outline:arrow_forward"></mat-icon>
      @if (requestData) {
        <fuse-card class="flex flex-col px-8 py-6 pb-4 bg-primary text-on-primary w-1/2" #fuseCard>
          <div class="text-xl">{{ 'newAddress' | transloco }}</div>
          <div class="text-md">{{ requestData.address.vicinity }}</div>
        </fuse-card>
      }
    </div>
    <div class="flex">
      <div class="border-2 border-solid border-black mb-4 z-0 w-1/2">
        <div class="h-120" [id]="mapId"></div>
      </div>
      <div class="flex justify-center mx-4 h-120 w-1/2">
        @if (imageUrl) {
          <img [src]="imageUrl" class="h-full w-auto">
        }
      </div>
    </div>
    <div class="flex flex-col w-full md:w-1/2 xl:w-1/3 2xl:w-1/4 border-2 border-solid border-black">
      <div class="flex justify-between items-center p-4">
        <img [src]="'/leaflet/images/marker-icon.png'" class="w-6 cursor-pointer" (click)="centerMapTo(itemMarker)">
        <span>{{ data.item.name }}</span>
      </div>
      <div class="flex justify-between items-center p-4">
        <img [src]="'assets/images/position-markers/marker-icon-red.png'" class="w-6 cursor-pointer" (click)="centerMapTo(requestMarker)">
        <span>{{ 'newAddress' | transloco }}</span>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex flex-0 flex-row justify-end gap-2 px-6 py-4 bg-gray-50 dark:bg-black dark:bg-opacity-10">
    <button (click)="reject()" mat-stroked-button>
      {{ 'reject' | transloco }}
    </button>
    <button (click)="approve()" mat-flat-button color="primary">
      {{ 'approve' | transloco }}
    </button>
  </div>
</div>